import { render } from "./CommentComponent.vue?vue&type=template&id=af53d6d6&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"

import "./CommentComponent.vue?vue&type=style&index=0&id=af53d6d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af53d6d6"]])

export default __exports__